module.exports = __webpack_public_path__ + "img/icon-right-arrow.f44a8efd.png";